import { captureError } from '../lib/error-reporting.js'
import { wrapError } from '../lib/wrap-error.js'

const objectToKVP = ([key, value]: [string, string | string[] | boolean | number]) => ({
  key: String(key),
  value: String(value),
})

type Information = Record<string, string>

export const useCaptureInteraction = () => {
  const captureInteraction = async (information: Information) => {
    try {
      const normalizedInformation = Object.entries(information).map(objectToKVP)

      await fetch('/api/captureInteraction', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          location: [{ key: 'url', value: window.location.href }],
          information: normalizedInformation,
        }),
      })
    } catch (error) {
      captureError(wrapError('useCaptureInteraction request', error))
    }
  }

  return { captureInteraction }
}
